import ProductSearchComponent from '../base/productSearchComponent';
export default class Pagination extends ProductSearchComponent {
    constructor(element) {
        super(element);
        this.endpoint = document.body.querySelector(this.selectors.productListWrapper).getAttribute('data-endpoint').split('?')[0] || '';
        window.productSearchData.currentPage = 1;
        this.listenForClick();
    }
    listenForClick() {
        this._el.addEventListener('click', () => {
            this.printMethod = 'append';
            window.productSearchData.searchParams.start = window.productSearchData.increment * window.productSearchData.currentPage;
            this.getPage(this._el);
        });
    }
    updateData() {
        window.productSearchData.counter = window.productSearchData.counter + window.productSearchData.increment;
        window.productSearchData.currentPage++;
        window.productSearchData.datalayerOffset = window.productSearchData.counter + 1;
        let excludedKeys = ['cgid', 'start', 'pmin'];
        let paginationKeys = Object.assign({}, window.productSearchData.searchParams);
        excludedKeys.forEach((key) => {
            delete paginationKeys[key];
        });
        window.productSearchData.searchQs = paginationKeys;
        window.productSearchData.searchQs.sz = window.productSearchData.counter;
    }
}
